import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from '@/pages/HomePage';
import Privacy from './components/Privacy';
import TermsOfService from './components/TermsOfService';
import TalentLanding from './components/TalentLanding';
import ScrollToTop from './components/ScrollToTop';
import WidgetInitializer from './components/WidgetInitializer';
import SevenMinutesLanding from './components/landings/SevenMinutesLanding';
import ZeroFeesLanding from './components/landings/ZeroFeesLanding';
import CapacityLanding from './components/landings/CapacityLanding';
import HoursLanding from './components/landings/HoursLanding';
import FiftyUpworkLanding from './components/landings/FiftyUpworkLanding';
import HirePodLanding from './components/landings/HirePodLanding';
import ConsultationLanding from './components/landings/ConsultationLanding';
import ConsultationWhatToExpectLanding from './components/landings/ConsultationWhatToExpectLanding';
import PodWhatToExpectLanding from './components/landings/PodWhatToExpectLanding';
import './App.css';

const MeetWithAnExpert = () => {
  useEffect(() => {
    window.location.replace('https://cal.com/matching-expert/30min');
  }, []);
  return null;
};

function RoutesWrapper() {
  const location = useLocation();

  return (
    <Routes key={location.pathname}>
      <Route path="/" element={<HomePage />} />
      <Route path="/talent" element={<TalentLanding />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/r/7minutes" element={<SevenMinutesLanding />} />
      <Route path="/r/zerofees" element={<ZeroFeesLanding />} />
      <Route path="/r/capacity" element={<CapacityLanding />} />
      <Route path="/r/hours" element={<HoursLanding />} />
      <Route path="/r/50upwork" element={<FiftyUpworkLanding />} />
      <Route path="/services/pod" element={<HirePodLanding />} />
      <Route path="/pod/what-to-expect" element={<PodWhatToExpectLanding />} />
      <Route path="/services/consultation" element={<ConsultationLanding />} />
      <Route path="/consultation/what-to-expect" element={<ConsultationWhatToExpectLanding />} />
      <Route path="/meet-with-an-expert" element={<MeetWithAnExpert />} />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div>
        <BrowserRouter>
          <ScrollToTop />
          <WidgetInitializer />
          <RoutesWrapper />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
